module.exports = __webpack_public_path__ + "static/talent-1b46bd822b6939043b67796807b5daea.png";